{
    "AlarmonnewabandonedcallLabel": "Alarm On New Abandoned Call:",
    "NAME": "AbandonedCallAlarm",
    "AbandonedCallAlarm_SectionHeader": "Abandoned Call Alarm",
    "AbandonedCallAlarm_SectionPara": "You can activate an alarm when new abandoned calls occur."
}